// extracted by mini-css-extract-plugin
export default {"header":"Header-module__header___aRovF","header_compressed":"Header-module__header_compressed___Sdn3V","header_opened":"Header-module__header_opened___E7YlU"};